module.exports = __webpack_public_path__ + "img/farming_23.8e37d9c9.png";